import Phaser from 'phaser'

import { cDisplay, createParam } from './cDisplay';
import { cScene, cSceneConfig } from './cScene';
import { cSceneGlobal } from './cSceneGlobal';
import { ScreenItem, ScreenObject } from './dataTypes'
import { StateHandler } from './utils/stateHandler';
import { logging } from "./utils/logging";

export interface configDataSet {
  phaser: Phaser.Types.Core.GameConfig
  adminCustomeTypes?: string[]
  statename: string
}

class cPhaserGame extends Phaser.Game {
  public state: StateHandler | null = null;
}

interface OverlayList {
  ref: cScene,
  cb: Function
}

export class cGame {

  public game!: Phaser.Game;
  public debugScreen!: string
  public state!: StateHandler;

  public sceneGlobal!: cSceneGlobal

  public static current: cGame;
  public static debugmode: boolean = false;
  public static language: string = 'de';

  public currentScene!: cScene
  public currentoverlays: OverlayList[];
  public ev: Phaser.Events.EventEmitter

  public onGoto!: Function

  constructor(configData: configDataSet) {
    this.state = new StateHandler(configData.statename)
    this.ev = new Phaser.Events.EventEmitter()
    this.registerCustomeObjects(configData.adminCustomeTypes as string[] || []);
    this.createGame(configData)
    this.currentoverlays = [];
    cGame.current = this

    this.game.sound.mute = this.state.get('sound_muted') === 1;

  }

  createGame(configData: configDataSet) {
    let config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      width: '100%',
      height: '100%',
      scale: {
        mode: Phaser.Scale.NONE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
      input:{
        activePointers: 1,
      },
      physics: {
        default: 'matter',
        matter: {
            enableSleeping: true,
            //debug:{}//MatterDebug
        }      
      }
    }
    this.game = new cPhaserGame({ ...config, ...configData.phaser })
  }

  public destroy() {
    this.game.destroy(true);
  }

  public set isActive(v: boolean) {
    if (this.game) {
      this.game.input.enabled = v
    }
  }

  /**
   * 
   * @param nm 
   * @param cb 
   */
  public addGlobelScene(nm: string = '_global', cb?: Function) {
    this.sceneGlobal = new cSceneGlobal('_global', '-load-')
    this.sceneGlobal.ev.addListener('ready', () => {
      if (cb) {
        cb();
      }
    })
    this.game!.scene.add('_global', this.sceneGlobal, true)
  }

  /**
   * 
   * @param data 
   * @param config 
   * @param onChange 
   */
  public createDebugScreen(data: ScreenObject, onChange: Function) {
    let nm = data.options.name

    if (this.debugScreen) {
      this.game.scene.remove(this.debugScreen)
    }

    if (nm === '_global') {
      this.game.scene.remove('_global')
    }

    cGame.debugmode = true;

    let screen = new cScene(nm, data);
    this.game.scene.add(nm, screen)
    this.game.scene.start(nm)
    this.game.scene.bringToTop('_global')

    this.debugScreen = nm

    screen.events.on('debug_position', (d: ScreenItem, newofs: string) => {
      let newData = { ...data }
      newData.screen.map((el, i) => {
        if (el.id === d.id) {
          el.ofs = newofs
        }
        return el
      })
      onChange(newData);
    })
  }


  /**
   * 
   * @param name 
   * @param options 
   * @param cb 
   * @returns 
   */
  public createScene(name: string, options: any, cb: Function | null ) {
    //console.log('CREATE SCENE', name);
    let newsc = new cScene(name, name, options)
    newsc.ev.addListener('action', this.handleCommand, this);
    newsc.ev.addListener('ready', () => {
      cb && cb()
    })
    
    this.game.scene.add(name, newsc, true);
    this.game.scene.bringToTop('_global')
    this.game.scene.bringToTop('_interface')
    if (this.currentoverlays.length > 0) {
      this.currentoverlays.forEach( layer=> this.game.scene.bringToTop(layer.ref) )
    }
    return newsc as cScene
    // }
  }



  /**
   * 
   * @param name 
   * @param options 
   * @param cb 
   */
  public setOverlay(name: string, options: any, cb: Function) {
    var $this = this;

    if (options){
      options = this.getJson(options);      
    }else{
      options = {}
    }

    options.isOverlay = true;
    console.log('SET OVELYA',options)
    var newLayer:cScene = new cScene(name, name, {sceneOptions:options} as any)

    newLayer.ev.addListener('action', function(command: string, commandObject: any){
      if (commandObject.command === 'close_overlay'){
        var l:any = $this.currentoverlays.pop() 

        if ($this.currentoverlays.length === 0) {
          $this.currentScene && $this.currentScene.scene.resume();
        }

        l.ref.close(()=>{ 
          l.cb({result:commandObject.options}); 
          $this.game.scene.remove(name)
          logging.log('closed',name)
        })
        return;
      }

      if (command === 'goto'){
        $this.handleCommand('goto', commandObject)
        return
      }

      $this.ev.emit('action', commandObject);
    },this)

    this.currentoverlays.push({
      ref: newLayer,
      cb: cb
    });

    var sc = this.game.scene.getScene(name)
    if (!sc){
      if (this.currentScene && this.currentScene.scene){
        this.currentScene.scene.pause();
      }
      this.game.scene.add(name, newLayer, true);
      this.game.scene.bringToTop('_interface');
    }else{
      console.warn('GAME ALREAD HAS SCENE', name)
    }

  }




  handleCommand(action: string, opt: any) {
    //console.log('GAME::',action)
    
    switch (action) {
      case 'global_reset':
        this.state.reset();
        window.location.reload();
        break;
      case 'scene_reset':
        var mod_res = cGame.current.state.get('module')
        var nm  = cGame.current.currentScene.sceneData.options.name
        this.state.remove(mod_res+'::'+nm)
        break;
      case 'goto':
        this.ev.emit('action', {...{command:'goto'},...opt})

        if (opt.options === '<last_visited_scene>'){
          var mod = cGame.current.state.get('module','1')
          opt.target = cGame.current.state.get(mod+'::last_visited_scene')
        }

        var sOptions: cSceneConfig = {
          sceneOptions: {}
        }
        this.currentoverlays.forEach( (el)=>(el.ref as cScene).close() );
        this.currentoverlays = [];
        if (opt.options) {
          sOptions.sceneOptions = this.getJson(opt.options)
        }
        if (this.currentScene && this.currentScene.sceneData && this.currentScene.sceneData.options && this.currentScene.sceneData.options.name === opt.target) {
          this.currentScene.scene.resume();
          this.currentScene.applyOptions(sOptions.sceneOptions)
          return
        }
        if (this.onGoto) this.onGoto(opt.target)
        var prevScene = this.currentScene;
        this.currentScene = this.createScene(opt.target, sOptions, () => {
          if (prevScene) prevScene.close();

          //console.log('SCENE IS NOW READY AND VISIBLE ::',opt.target)
          if (String(opt.target).indexOf('00_') !== 0 && String(opt.target).indexOf('_start') === -1){
            var mod = this.state.get('module','')
            this.state.set(mod + '::last_visited_scene', opt.target)
          }
        })
        break;
      default:
        this.ev.emit('action', opt)
    }
  }


  private getJson(data:any){
    var res;

    if (typeof data === 'object') return data

    try {
      res = JSON.parse(data);
    }catch (e){
      console.warn('Unable to parse JSON ', data)
      res = {}
    }    
    return res;
  }


  /**
   *
   *
   * @readonly
   * @type {cScene}
   * @memberof cGame
   */
  public get debugScene(): cScene {
    return this.game.scene.getScene(this.debugScreen as string) as cScene
  }


  public getStyle(name: string): Phaser.Types.GameObjects.Text.TextStyle {
    return this.sceneGlobal.sceneStyles[name] || {}
  }


  protected registerCustomeObjects(types: string[]) {
    types.forEach((s) => {
      cDisplay.registerDisplayType(s, (opt: createParam) => {
        return new cDisplay(opt.scene, opt.data, opt.onReady);
      })
    })
  }

}